import pathfinder from '@fiverr-private/pathfinder';

export interface TestimonialItem {
    key: string;
    imageSrc: string;
    name: string;
    position: string;
    quote: string;
    infoTitle: string;
    infoDescription: string;
    video: string;
    infoCtaHref: string;
    sellers: {
        image: string;
        name: string;
        position: string;
        rating: number;
        isPro: boolean;
        href: string;
        isBadgeTop?: boolean;
        isAgency?: boolean;
    }[];
}

export const TESTIMONIALS_ITEMS: TestimonialItem[] = [
    {
        key: '1',
        imageSrc:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/80601a1ca16f54b04e36d735f9b38c9d-1762450343923/brand-lohp-v17-testimonials-poster-1.png',
        name: 'v17.testimonials.items.1.name',
        position: 'v17.testimonials.items.1.position',
        quote: 'v17.testimonials.items.1.quote',
        infoTitle: 'v17.testimonials.items.1.info.title',
        infoDescription: 'v17.testimonials.items.1.info.description',
        video: 'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/9c829771fe4b6fd0635cea0d676ba726-1762449872397/brand-lohp-v17-testimonials-1',
        infoCtaHref: pathfinder('content_pages_page', { page_slug: 'books-publishing' }),
        sellers: [
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/962786054d14d20cc7bf7fa6187c4fa4-1724154964943/6d5d0d58-bbcf-4b87-b2f6-7a1f26315e25.png',
                name: 'Sparrow',
                position: 'Agency',
                rating: 4.9,
                isPro: true,
                isAgency: true,
                href: 'https://www.fiverr.com/agencies/sparrow',
            },
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/3c127f86e7be1eaedd515c4645697afa-1733162755615/e819d7a5-5466-4d08-bafc-6e7d21f86391.jpg',
                name: 'Ade Chintya',
                position: 'Illustrator',
                rating: 4.9,
                isPro: true,
                href: 'https://www.fiverr.com/adechintya_p',
            },
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/ab957ef20a33054f6878e12ffc9785b1-1658081182755/3e0da4c0-c109-408b-8029-e9364d6daa93.png',
                name: 'Ana',
                position: 'Editor and Proofreader',
                rating: 4.9,
                isPro: true,
                isBadgeTop: true,
                href: 'https://www.fiverr.com/anajoldesx',
            },
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/ae51e77ec4cc4dbf7895d1901ab872c7-1743744992830/6db2d970-b17b-4f43-a121-d69d8c42f9f0.png',
                name: 'Emma Moylan',
                position: 'Copyeditor',
                rating: 4.9,
                isPro: true,
                href: 'https://www.fiverr.com/emma_moylan',
            },
        ],
    },
    {
        key: '2',
        imageSrc:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/80601a1ca16f54b04e36d735f9b38c9d-1762450343939/brand-lohp-v17-testimonials-poster-2.png',
        name: 'v17.testimonials.items.2.name',
        position: 'v17.testimonials.items.2.position',
        quote: 'v17.testimonials.items.2.quote',
        infoTitle: 'v17.testimonials.items.2.info.title',
        infoDescription: 'v17.testimonials.items.2.info.description',
        video: 'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/60c00b713153e7ebf64922bdf79f085a-1762450038322/brand-lohp-v17-testimonials-2',
        infoCtaHref: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'website-development' },
            { query: { source: 'category_tree' } }
        ),
        sellers: [
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/a13bd40046440777cdc0822fd4d4842f-1744567635602/1b067d2d-cc1a-4995-9f8a-6839d187cde3.png',
                name: 'Wpdev',
                position: 'Wordpress Developer',
                rating: 4.7,
                isPro: false,
                href: 'https://www.fiverr.com/wpdev_5',
            },
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/72b61f2a56325751bd6dcf4465b7e258-1706302595191/536e2072-b78b-497b-b77e-e8d370cd4aae.jpg',
                name: 'Iconprosolution',
                position: 'Agency',
                rating: 4.9,
                isPro: true,
                href: 'https://www.fiverr.com/agencies/iconprosolution',
            },
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/0dc4df29f8b5a4cd63c32b831ceee8f1-1756845098930/b2e9c60b-b841-45ed-a8ac-c0750d8a7c4e.png',
                name: 'Shohel',
                position: 'Ecommerce Expert',
                rating: 4.7,
                isPro: false,
                href: 'https://www.fiverr.com/jerinlab',
            },
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/1ca2b4fba2172faee0abaeb770e1e7cf-1670083392371/8e76a89f-684d-43ac-816e-fc2c33d87e4f.png',
                name: 'Eva Design',
                position: 'Web Developer',
                rating: 4.9,
                isPro: false,
                href: 'https://www.fiverr.com/eva_design32',
            },
        ],
    },
    {
        key: '3',
        imageSrc:
            'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/80601a1ca16f54b04e36d735f9b38c9d-1762450343932/brand-lohp-v17-testimonials-poster-3.png',
        name: 'v17.testimonials.items.3.name',
        position: 'v17.testimonials.items.3.position',
        quote: 'v17.testimonials.items.3.quote',
        infoTitle: 'v17.testimonials.items.3.info.title',
        infoDescription: 'v17.testimonials.items.3.info.description',
        video: 'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/60c00b713153e7ebf64922bdf79f085a-1762450038311/brand-lohp-v17-testimonials-3',
        infoCtaHref: pathfinder('vibe_coding_page'),
        sellers: [
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/e13502a07d8ee8c4fb60da4cf78374e4-1755795756377/43ac8fb4-73f0-4a51-aae7-6d4aabbc25a3.png',
                name: 'Loopus Tech',
                position: 'Developer',
                rating: 4.9,
                isPro: true,
                href: 'https://www.fiverr.com/loopus_web',
            },
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/b9d73f84027dbb37abd7bef2b4756409-1646421115751/45471173-9a4e-42d2-84dc-71934de90205.jpg',
                name: 'Hekmat',
                position: 'Software Development',
                rating: 4.7,
                isPro: false,
                href: 'https://www.fiverr.com/hekmatnajafi',
            },
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/30601505102b26050c72db7b7d1aab7f-1758023729399/7e9b80c3-58f7-4f85-afb5-29d86f0c1be9.png',
                name: 'Rayyaan',
                position: 'Developer',
                rating: 4.9,
                isPro: true,
                href: 'https://www.fiverr.com/rayyaannauman',
            },
            {
                image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto,t_profile_original/v1/attachments/profile/photo/2c5305bcc11d30c2e2b1f81ae833fb6f-1734353842620/e16308e5-3765-4ffe-8978-be8e79d9f832.jpg',
                name: 'Hyperinventive',
                position: 'Agency',
                rating: 4.9,
                isPro: true,
                isAgency: true,
                href: 'https://www.fiverr.com/agencies/hyperinventive',
            },
        ],
    },
];
